import Component from './component';

Component.defaultProps = {
    memoParams: [],
    localTranslations: {},
};
export default Component;